import styled from 'styled-components';

export const Header = styled.h2`
  font-family: var(--secondary-font);
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  color: #13171b;
`;

export const ErrorItem = styled.div`
  display: flex;
`;

export const ErrorText = styled.div`
  line-height: 26px;
  font-size: 14px;
  text-align: justify;
  width: 90%;
  margin-left: 10px;
  white-space: pre-wrap;
`;
